import { render, staticRenderFns } from "./QualificationCategory.vue?vue&type=template&id=66f4f5e1&"
import script from "./QualificationCategory.vue?vue&type=script&lang=js&"
export * from "./QualificationCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports